<template>
<td v-if="!dataItem.inEdit" :class="className">{{ dataItem[field]}}</td>
    <td v-else>
        <div>
            <autocomplete 
                :value="selectedItem"
                :data-items="autocompleteData" 
                :text-field="'id'"
                :item-render="'sifrantItemTemplate'"
                @change="onChangeAutocomplete"
                @close="onCloseAutocomplete"
                @blur="onBlurAutocomplete"
                :style="{ width: '150px' }"
                ref="ac"
                :opened="opened"
                :valid="valid"
                :validation-message="'Neveljavna izbira šifranta'"

             
            >
        <template v-slot:sifrantItemTemplate="{ props }">
        <sifrantItem
          :data-item="props.dataItem"
          :focused="props.focused"
          :index="props.index"
          @click="(e,dataItem) => onSifrantItemClick(e,dataItem,props)"
        />
      </template>

            </autocomplete>
              <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="prikaziSifrant" title="Šifrant">
                         <font-awesome-icon icon="list"/>
                    </button>
<k-dialog v-if="izbiranSifrat" @close="zapriSifrant">
                 <dropdowntree 
                :data-source="sifrantTree" 
                :data-text-field="'naziv'"
                :data-value-field="'id'"
                :data-item-key="'id'"

                :filter="'contains'"
                :value="izbranaVrednost"
                @change="onChange"
                :placeholder="'Izberi...'"
                @select="onSelect"
                @open="onOpen"
                style="width: 300px;"
                :template="vrniTemplate"
                ref="sifrant"
                >
             
                </dropdowntree>
            <dialog-actions-bar>
                
                <button
                    class="k-button k-primary"
                    @click="zapriSifrantInShrani"
                >
                    Izberi
                </button>
                <button
                    class="k-button"
                    @click="zapriSifrant"
                >
                    Prekliči
                </button>
            </dialog-actions-bar>
        </k-dialog>

   
</div>
    </td>
</template>
<script>
import { Input } from '@progress/kendo-vue-inputs';
import { markRaw } from 'vue';
import { AutoComplete } from '@progress/kendo-vue-dropdowns';
import { DropDownTree } from '@progress/kendo-dropdowntree-vue-wrapper';
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import { filterBy } from '@progress/kendo-data-query';
import SifrantProizvodItem from "./SifrantProizvodItem";
import Vue from 'vue'
export default {
    components: {
        'autocomplete': AutoComplete,
         'sifrantItem': SifrantProizvodItem,
  'dropdowntree': DropDownTree,
   'k-dialog': Dialog,
        'dialog-actions-bar': DialogActionsBar

},
created(){

console.log(this.sifrantData);
this.selectedItem=this.dataItem.naziv;

},

 
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
       sifrantData:Array,
       sifrantTree:Object
       
    },
     watch: {
      'dataItem.naziv':function (newVal, oldVal) {
         this.selectedItem=newVal;
      }
   },
    computed:{

       autocompleteData(){
            return this.sifrant;
            },
        valid: function(){

            return this.sifrantId != null;

        },
        validationMessage: function(){
            //če ni, napiši, v čem je problem....
        }     
    },
    
    data: function () {
    return {
        opened:undefined,
      selectedItem:"",
      sifrant:this.sifrantData,
      izbiranSifrat:false,
      sifrantId:this.dataItem.proizvodid,
      sifrantNaziv:this.dataItem.naziv,
      izbranaVrednost:{}
    };
  },

    
    methods: {
        prikaziSifrant(e){
      
            console.log("PRIKAZISIFRANTSTART");
            console.log(this.value);
            this.izbiranSifrat=true;
            var thisApp=this;
            Vue.nextTick(function () {
    // container IS finished rendering to the DOM
             thisApp.izbranaVrednost={id:thisApp.dataItem.proizvodid,naziv:thisApp.dataItem.naziv};
            })

            //    Vue.set(this,'izbranaVrednost',{id:this.dataItem.proizvodid,naziv:this.dataItem.naziv});

          
        },
         zapriSifrant(e){
            this.izbiranSifrat=false;
          
        },
          zapriSifrantInShrani(e){
            this.izbiranSifrat=false;
            console.log("SKRIJSIFRANT");
            this.selectedItem=this.sifrantNaziv;
            this.$emit('change',{id:this.sifrantId,naziv:this.sifrantNaziv}, this.dataItem);

        },
        onChange(e) {
       
          
            this.sifrantId=e.sender.value();
            this.sifrantNaziv=e.sender.text();


         //   

        },
        onChangeAutocomplete(e) {
     
          this.opened=undefined;
            console.log(e.target.value);
              this.selectedItem=e.target.value;
               this.sifrantId=null;
             this.sifrant = this.filterData(event.target.value);

          

            
         //   

        },
        onBlurAutocomplete(e) {
       this.$emit('change',{id:this.sifrantId,naziv: this.sifrantNaziv}, this.dataItem);

        },

        onCloseAutocomplete(e) {
    
        if(!e.component.focusedItem){
          if(e.component.dataItem&&e.component.dataItem.length>0) {
                var selectedItem=e.component.dataItem[0];
                this.sifrantId=selectedItem.id;
            this.sifrantNaziv=selectedItem.naziv;
            this.selectedItem=this.sifrantNaziv;
             this.$emit('change',{id:this.sifrantId,naziv: this.sifrantNaziv}, this.dataItem);
          }
          else {
            this.sifrantId=null;
             this.$emit('change',{id:this.sifrantId,naziv: e.component.currentValue}, this.dataItem);

            }
        }
        else if(e.component.focusedItem.id)
        {
            this.sifrantId=e.component.focusedItem.id;
            this.sifrantNaziv=e.component.focusedItem.naziv;
            this.selectedItem=this.sifrantNaziv;
             this.$emit('change',{id:this.sifrantId,naziv: this.sifrantNaziv}, this.dataItem);
        }
            
              

            
         //   

        },
        
        onSifrantItemClick(e,dataItem,props,ac){
            this.selectedItem=dataItem.naziv;
            props.selected=true;
           
            this.sifrantId=dataItem.id;
            this.sifrantNaziv=dataItem.naziv;
            this.$emit('change',{id:dataItem.id,naziv:dataItem.naziv}, dataItem);
            this.opened=false;

        },
        filterData(value) {
            const data = this.sifrantData;
            const filter = {
                field:'naziv',
                value: value,
                operator: 'startswith',
                ignoreCase: true
            };
            return value ? filterBy(data, filter) : data;
        },
     
        onSelect(e) {
            //console.log(e.sender.dataItem(e.node).jeaktivna);
            if(!e.sender.dataItem(e.node).jeaktivna){
                e.sender.treeview.toggle(e.node);
                e.preventDefault();
          }
          this.value=e.sender.value();
        this.sifrantId=e.sender.value();
         this.sifrantNaziv=e.sender.text();
        },
        onOpen(e) {
           
        },
        itemDisabled(e) {
            console.log("Item Disabled");
            console.log(e.dataItem);
           
      },
        vrniTemplate(e) {
        
          var css=' class="k-state-disabled"';
          if(e.item.jeaktivna)
            css=""

        var html="<span"+css+">"+e.item.naziv+"</span>";
        
        return html;
          
       }
    },
   
}
</script>

var data=[];


}